import { MatterClientIntakeFormState } from '@state/matter/client-intake/client-intake.state';
import { IntakeFormClientResponsesSelectors } from '@domain/intake-form-client-responses';
import { createSelector } from '@ngxs/store';
import { IntakeFormStatus } from '@models/client-intake';
import { IntakeFormStatusDropdownOptions } from '../../client-intake-page/view-models/models';

export const $intakeRequestViewModel = createSelector(
	[
		MatterClientIntakeFormState.getMostRecentActiveForm,
		IntakeFormClientResponsesSelectors.$intakeResponseStatusCounts,
		IntakeFormClientResponsesSelectors.$intakeResponseMatterProgress,
		IntakeFormClientResponsesSelectors.$intakeFormResponses,
	],
	(intakeForm, statusCounts, matterProgress, intakeFormResponses) => {
		const canShowReviewButton =
			intakeFormResponses.length > 0 &&
			intakeForm?.status === IntakeFormStatus.REVIEW_UPDATES;

		const displayedStatus =
			IntakeFormStatusDropdownOptions.find((option) => {
				return option.id === intakeForm?.status;
			})?.title || null;

		console.log({
			intakeForm,
			statusCounts,
			matterProgress,
			canShowReviewButton,
		});
		return {
			intakeForm,
			statusCounts,
			matterProgress,
			canShowReviewButton,
			displayedStatus,
		};
	},
);
